/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

export const GetSimulationPavillonInformationCitiesQuery = gql`
  query GetSimulationPavillonInformationCitiesQuery($postalCode: String) {
    getSimulationPavillonInformationCities_simulation_pavillon_information(postalCode: $postalCode) {
      cities {
 value  
label  
}
    }
  }
`;

export default GetSimulationPavillonInformationCitiesQuery;
